import styled from 'styled-components';
import { motion } from 'framer-motion';
import { max, min } from '../../../../theme/breakpoints';

export const PromoCardWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  width: 95%;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 0.5rem 1.875rem 0.5rem;

  > img {
    width: 23%;

    @media screen and ${max('desktop')} {
      width: 30%;
    }

    @media screen and ${max('largeTablet')} {
      height: 144px;
      width: 100%;
      object-fit: cover;
    }
  }

  @media screen and ${max('desktop')} {
    width: 100%;
  }

  @media screen and ${max('largeTablet')} {
    height: 100%;
    flex-direction: column;
  }
`;

export const Details = styled.div`
  margin: 1.375rem;

  @media screen and ${min('largeTablet')} {
    margin: 2rem 3.125rem;
  }

  h3 {
    font-family: ${({ theme }) => theme.fonts.primary.bold};
  }
  > h4 {
    font-size: 1.5rem;
    letter-spacing: 0.04rem;
    padding: 0;
    text-transform: none;

    @media screen and ${max('desktop')} {
      font-size: 1.25rem;
      margin-bottom: 0;
    }

    @media screen and ${max('largeTablet')} {
      font-size: 1.5625rem;
    }
  }
  h3,
  p {
    text-align: center;

    @media screen and ${min('largeTablet')} {
      text-align: left;
    }
    a {
      text-decoration: underline;
    }
  }

  > p,
  a {
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.125rem;
    letter-spacing: 0.04rem;
    line-height: 1.65rem;

    @media screen and ${max('desktop')} {
      font-size: 1rem;
      line-height: 1.125rem;
    }
  }

  a {
    font-family: ${({ theme }) => theme.fonts.primary.regular};
    transition: 0.2s all ease-in-out;

    @media screen and ${min('largeTablet')} {
      &:hover {
        opacity: 0.5;
      }
    }
  }

  @media screen and ${max('largeTablet')} {
    line-height: 1.3125rem;
    align-items: center;
  }
`;

export const UbiPlusSection = styled.div`
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0 1.875rem 1.875rem 0;
  width: 14rem;

  > a {
    font-family: ${({ theme }) => theme.fonts.primary.regular};
    color: ${({ theme }) => theme.colors.text};
    font-size: 0.875rem;
    white-space: nowrap;
    text-decoration: underline;
    transition: 0.2s all ease-in-out;

    @media screen and ${min('largeTablet')} {
      &:hover {
        opacity: 0.5;
      }
    }
    @media screen and ${max('desktop')} {
      font-size: 0.8rem;
    }
  }

  > svg {
    height: 2.5rem;
    width: 9rem;

    * {
      fill: ${({ theme }) => theme.colors.text};
    }
    > path:last-child {
      fill: ${({ theme }) => theme.colors.HavelockBlue};
    }

    @media screen and ${max('desktop')} {
      height: 2rem;
      width: 8rem;
    }
  }
  @media screen and ${max('largeTablet')} {
    padding: 0;
    margin: 0 auto 1rem;
    align-items: center;
    justify-content: center;
  }
`;

export const PromoFeature = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  min-height: 2.125rem;
  margin-bottom: 1rem;
  background-color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.OuterSpace : theme.colors.Mystic)};

  @media screen and ${min('largeTablet')} {
    margin-bottom: 0;
    margin-right: 1.25rem;
  }
  > p {
    font-family: ${({ theme }) => theme.fonts.primary.bold};
    color: ${({ theme }) => theme.colors.text};
    font-size: 1rem;
    margin: 0 0.25rem;

    > span {
      color: ${({ theme }) => theme.colors.Carnation};
    }
    @media screen and ${max('desktop')} {
      font-size: 0.8rem;
    }
  }

  @media screen and ${max('desktop')} {
    padding: 0.25rem 0.45rem;
  }

  @media screen and ${max('largeTablet')} {
    font-size: 1.125rem;
  }
`;

export const PromoFeaturesWrapper = styled.div`
  display: inline-flex;
  border-radius: 4px;
  width: 100%;

  @media screen and ${min('tablet')} {
    padding: 0 2rem;
  }
  @media screen and ${min('largeTablet')} {
    padding: 0;
  }
  @media screen and ${min('largeTablet')} {
    width: auto;
  }
  @media screen and ${max('largeTablet')} {
    background-color: ${({ theme }) => theme.colors.background};
    flex-direction: column;
  }
`;

export const PromoDetails = styled.p`
  margin: 1.5rem 0;
`;
